import Swiper from 'swiper'

function initSlider (slider) {
  return new Swiper(slider, {
    a11y: {
      firstSlideMessage: 'Erstes Produkt',
      lastSlideMessage: 'Letztes Produkt',
      nextSlideMessage: 'Nächstes Produkt',
      prevSlideMessage: 'Vorheriges Produkt'
    },
    loop: true,
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev'
    },
    spaceBetween: 32
  })
}

const sliders = document.querySelectorAll('.js-swiper-image')

/**
 * This slightly obscure contruct is necessary because:
 * - On page load an accordion is collapsed
 * - This confuses Swiper and therefore the slider is broken
 * - The solution is to wait with the Swiper intialization
 */
for (let i = 0; i < sliders.length; i++) {
  const panel = jQuery(sliders[i]).closest('.panel')

  if (panel.length) {
    panel.on('shown.bs.collapse', () => initSlider(sliders[i]))
  } else {
    initSlider(sliders[i])
  }
}



// WEBPACK FOOTER //
// ./src/components/img-slider/scripts.js